import Vue from 'vue'
import App from './App.vue'
import axios from "axios";
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false

if(window.location.hostname=='pointclickcare.com'){
  // console.log(window.location.hostname);
  axios.defaults.baseURL = "https://pointclickcare.com/";
} else if(window.location.hostname=='pccstaging.wpengine.com') {
  // console.log(window.location.hostname);
  axios.defaults.baseURL = "https://pccstaging.wpengine.com";
} else if(window.location.hostname=='pcccorpdev.wpengine.com') {
  axios.defaults.baseURL = "https://pcccorpdev.wpengine.com";
} else {
  axios.defaults.baseURL = "https://pcccorpdev.wpengine.com";
}
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

new Vue({
  render: h => h(App),
}).$mount('#app')
